<div class="module-wrapper">
    <div class="module drop-shadow bottom">
        <table *ngIf="interactions.length > 0" class="std-table stacked-sm">
            <thead>
            <th>Status</th>
            <th>Interaction type</th>
            <th>Consumer name</th>
            <th>Supply address</th>
            <th>Requested</th>
            <th>Scheduled</th>
            <th></th></thead>
            <tbody>
                <tr *ngFor="let item of interactions">
                    <td data-label="Status"><span class="h-uppercase h-bold" [ngClass]="{'text-color__error': (item.requestStatus == 'Error' || item.requestStatus == 'Expired'), 'text-color__warning': (item.requestStatus == 'Processing' || item.requestStatus == 'Accepted' || item.requestStatus == 'Initialised'), 'text-color__success': (item.requestStatus == 'Completed')}">{{item.requestStatus == 'Processing' || item.requestStatus == 'Accepted' || item.requestStatus == 'Initialised' ? 'In Progress' : item.requestStatus }}</span></td>
                    <td data-label="Interaction type">{{item.requestName}}</td>
                    <td data-label="Consumer name">{{item.consumerName}}</td>
                    <td data-label="Supply address">{{item.consumerAddress}}</td>
                    <td data-label="Requested">{{item.requestDate | date:'dd/MM/yyyy, H:mm'}}</td>
                    <td data-label="Scheduled">{{  item.scheduleTime ? (item.scheduleTime | date:'dd/MM/yyyy, H:mm') : ''}}</td>
                    <td class="text-right">
                        <a [routerLink]="['/portal/'+ clientId +'/consumer', item.consumerID]" class="text-link focus-element">
                            <span class="focus--content" tabindex="-1">View</span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="interactions.length == 0" class="text-center">
            No interactions
        </div>
       
    </div>
</div>
